import Generic from "./generic"
import toast from '../utils/toast';

const useAluno = () => {

    const { GenericPost } = Generic();

    const createPreCadastro = async ({aluno}) => {
        //console.log(aluno);
        if(!aluno.nome || !aluno.sobrenome || !aluno.cpf || !aluno.telefone || !aluno.autoescola_id){
            toast.error("Por favor, preencha todos os campos obrigatórios.");
            return;
        }

        const response = await GenericPost({ rota: "usuario", caminho: "preCadastro", body: aluno });

        if(!response.success){
            toast.error(response.error || "Erro ao criar pré-cadastro.");
            return false;
        }else{
            toast.success("Pré-cadastro criado com sucesso!");
            return true;
        }
    }

    return {
        createPreCadastro
    }
}

export default useAluno;